import { useCallback } from 'react';

import { Tasks } from '@air/api';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { type BoardRestorationTask, type GetBaseMetadata } from '~/store/tasks/types';
import { useCreateTask } from '~/utils/taskUtils/useCreateTask';

export type CreateBoardRestorationTaskParams = GetBaseMetadata<BoardRestorationTask>;

export type NewParentLocation = CreateBoardRestorationTaskParams['parent'];

export const useBoardRestorationTask = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const { createTask } = useCreateTask();

  const createBoardRestorationTask = useCallback(
    ({ boardId, parent, title }: CreateBoardRestorationTaskParams) => {
      const workspaceId = currentWorkspace?.id;
      if (!workspaceId) {
        throw new Error('No workspace id');
      }
      return createTask({
        task: {
          metadata: { boardId, parent, title },
          type: 'BoardRestoration',
        },
        createTask: () =>
          Tasks.createTask({
            workspaceId,
            task: {
              type: 'ContentRestorer',
              args: { boardId, parent: parent === 'root' ? null : parent },
            },
          }),
      });
    },
    [createTask, currentWorkspace?.id],
  );

  return { createBoardRestorationTask };
};
